import * as React from "react";
import {Box ,  Drawer as MuiDrawer, Divider  } from "@mui/material";
import DrawerHeadBox from "../drawerHead/drawerHead";
import LeftNavbarLists from "../leftNavLists/leftNavbarLists";



export default function MobileViewDrawer({ open, setOpen ,handleDrawerClose  }) {
  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setOpen(open);
  };

  return (
    <div>
      <MuiDrawer anchor={"left"} open={open} onClose={toggleDrawer(false)} sx={{overflow:'hidden'}}>
      <DrawerHeadBox handleDrawerClose={handleDrawerClose} />
        <Divider />
        <Box
          sx={{ width: 240 }}
          role="presentation"
          onClick={toggleDrawer(false)}
          onKeyDown={toggleDrawer(false)}
        >
          <LeftNavbarLists open={open} />
        </Box>
      </MuiDrawer>
    </div>
  );
}
